import { render } from "./SelectableIDList.vue?vue&type=template&id=c4499366"
import script from "./SelectableIDList.vue?vue&type=script&lang=js"
export * from "./SelectableIDList.vue?vue&type=script&lang=js"

import "./SelectableIDList.vue?vue&type=style&index=0&id=c4499366&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__